import { Timeline } from 'antd';
import useStyle from './index.styles';

const TimelineInMemorial = ({
  onClickInImage,
  timeLineArray,
}: {
  onClickInImage?: (name: string, url: string) => void;
  timeLineArray: { date: string; description: string; imageUrl: string; imageName: string }[];
}) => {
  const classes = useStyle();

  const getDot = (direction: 'right' | 'left' = 'left', date: string) => {
    return (
      <div className="flex items-center bg-[transparent]">
        {direction === 'left' && (
          <div className={`${classes.line} left flex items-center`}>
            <div className={classes.point} />
            <div className="line" />
          </div>
        )}
        <div className="flex h-[118px] w-[118px] items-center justify-center rounded-full border border-solid border-bg1 bg-white leading-[24px]">
          {date}
        </div>
        {direction === 'right' && (
          <div className={`${classes.line} right flex items-center`}>
            <div className="line" />
            <div className={classes.point} />
          </div>
        )}
      </div>
    );
  };

  const getDotMobile = () => {
    return (
      <div
        className={`flex h-[26px] w-[26px] items-center justify-center rounded-full border border-solid border-bg1`}
      >
        <div className={`h-[10px] w-[10px] rounded-full bg-primary`} />
      </div>
    );
  };

  return (
    <>
      <div className="hidden md:block">
        <Timeline className={classes.container} mode="alternate">
          {timeLineArray?.map((e, i: number) => (
            <Timeline.Item
              key={`timeLine-${i}`}
              label={
                !!e.imageUrl && (
                  <img
                    onClick={() => onClickInImage?.(e.imageName, e.imageUrl)}
                    src={e.imageUrl}
                    alt=""
                    className="max-h-[158px] min-h-[158px] min-w-[158px] max-w-[158px] cursor-pointer rounded-[8px] object-cover"
                  />
                )
              }
              dot={getDot(i % 2 === 0 ? 'right' : 'left', e.date)}
            >
              {e.description}
            </Timeline.Item>
          ))}
        </Timeline>
      </div>
      <div className="mt-[24px] block md:hidden">
        <Timeline className={classes.container} mode="right">
          {timeLineArray?.map((e, i: number) => (
            <Timeline.Item key={`timeLine-mobile-${i}`} label={e.date} dot={getDotMobile()}>
              <div className="ml-[calc(30%+24px)] flex flex-col items-start pb-[24px] pt-[56px]">
                <span>{e.description}</span>
                {!!e.imageUrl && (
                  <img
                    onClick={() => onClickInImage?.(e.imageName, e.imageUrl)}
                    src={e.imageUrl}
                    alt=""
                    className="max-h-[158px] min-h-[158px] min-w-[158px] max-w-[158px] cursor-pointer rounded-[8px] object-cover"
                  />
                )}
              </div>
            </Timeline.Item>
          ))}
        </Timeline>
      </div>
    </>
  );
};

export default TimelineInMemorial;
